import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {
    FIELD_LIST_INPUT_MAIN_BANNER_AVOSKIN_TRAIL_RUN,
    FIELD_NAME_INPUT_MAIN_BANNER_AVOSKIN_TRAIL_RUN
} from "../../utils/input-field-list-static-page";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";
import {convertErrorMessage} from "../../utils/general-variable";
import React, {useEffect} from "react";
import {
    setAvoskinTrailRunErrorMessage,
    setAvoskinTrailRunMainBannerDetail
} from "../../reducers/avoksin-trail-run.reducer";
import FormGeneralComponent from "../../components/static-page/form-general.component";

const MainBanner = () => {
    const dispatch = useDispatch()
    const {mainBannerDetail, avoskinTrailRunErrorMessage} = useSelector(state => state.avoskinTrailRunReducer)
    const {fetching: getMainBanner} = useFetch(API.AVOSKIN_TRAIL_RUN_GET_MAIN_BANNER)
    const {fetching: updateMainBanner, isLoading} = useFetch(API.AVOSKIN_TRAIL_RUN_UPDATE_MAIN_BANNER)
    let fieldListInput = FIELD_LIST_INPUT_MAIN_BANNER_AVOSKIN_TRAIL_RUN
    let showMainBanner = {
        label: 'Main Banner',
        key: 'show_main_banner',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setAvoskinTrailRunMainBannerDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        updateMainBanner(mainBannerDetail).then(response => {
            dispatch(setAvoskinTrailRunErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Main Banner Updated'))
            dispatch(setAvoskinTrailRunMainBannerDetail(response?.data))
        }).catch(err => {
            dispatch(setAvoskinTrailRunErrorMessage(convertErrorMessage(err, {}, FIELD_NAME_INPUT_MAIN_BANNER_AVOSKIN_TRAIL_RUN)))
        })
    }

    useEffect(() => {
        getMainBanner().then(response => {
            dispatch(setAvoskinTrailRunMainBannerDetail(response?.data))
        })

        return () => {
            dispatch(setAvoskinTrailRunErrorMessage({}))
        }
    }, [])

    return (
        <FormGeneralComponent
            data={mainBannerDetail}
            switchToggleField={showMainBanner}
            fieldList={fieldListInput}
            onChange={onChange}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'grid grid-cols-2 gap-x-16 gap-y-4'}
            errorMessage={avoskinTrailRunErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default MainBanner
